module.exports = __webpack_public_path__ + "media/images/search-249140c58ad9968d4b1728af86c3b04b.svg";